// pages/RedefinirSenha.jsx
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Input from "../shared/form/Input";
import styles from "./RedefinirSenha.module.css";

function RedefinirSenha() {
  const { token } = useParams();
  const [senha, setSenha] = useState("");
  const navigate = useNavigate();

  const redefinirSenha = async (e) => {
    e.preventDefault();
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API_URL}/redefinir-senha/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ senha }),
      });

      if (response.ok) {
        alert("Senha redefinida com sucesso!");
        navigate("/login");
      } else {
        const data = await response.json();
        alert(data.message || "Erro ao redefinir senha");
      }
    } catch (error) {
      alert("Erro: " + error);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconWrapper}>
            <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h2>Redefinir Senha</h2>
          <p className={styles.subtitle}>Digite sua nova senha abaixo para recuperar o acesso à sua conta.</p>
        </div>

        <form onSubmit={redefinirSenha} className={styles.form}>
          <div className={styles.inputGroup}>
            <Input
              type="password"
              text=""
              name="senha"
              placeholder="Digite sua nova senha"
              handleOnChange={(e) => setSenha(e.target.value)}
            />
          </div>

          <button type="submit" className={styles.btn}>
            Redefinir Senha
          </button>

          <div className={styles.footer}>
            <button
              type="button"
              className={styles.backBtn}
              onClick={() => navigate("/login")}
            >
              Voltar para Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RedefinirSenha;
